export const STRIPE_PERCENT_FEE = 0.029;
export const STRIPE_FIXED_FEE = 0.3;

export const roundHalfUpCurrency = (value) => {
	const num = Number(value);
	if (!Number.isFinite(num)) {
		return 0;
	}
	return parseFloat(num.toFixed(2));
};

export const formatCurrency = (value) => {
	const num = Number(value);
	if (!Number.isFinite(num)) {
		return '0.00';
	}
	return num.toLocaleString('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
};

export const calculateGrossUpAmount = (netAmount) => {
	const net = Number(netAmount);
	if (!Number.isFinite(net) || net <= 0) {
		return 0;
	}
	const gross = (net + STRIPE_FIXED_FEE) / (1 - STRIPE_PERCENT_FEE);
	return roundHalfUpCurrency(gross);
};

export const calculateStripeFee = (chargeAmount) => {
	const charge = Number(chargeAmount);
	if (!Number.isFinite(charge) || charge <= 0) {
		return 0;
	}
	const fee = charge * STRIPE_PERCENT_FEE + STRIPE_FIXED_FEE;
	return roundHalfUpCurrency(fee);
};

export const buildCardFeeNotice = (chargeAmount) => {
	const fee = calculateStripeFee(chargeAmount);
	return `If you pay this invoice online by card, a credit card processing fee of approximately $${formatCurrency(fee)} (2.9% + $0.30) will apply.`;
};

const rowLineTotal = (row) =>
	Number(row.quantity || 0) * Number(row.unit_price || 0);

export const applyStripeFeeToHighestLineItem = (lineItems) => {
	if (!lineItems?.length) {
		return { rows: [], targetDescription: '', feeDelta: 0 };
	}

	const working = lineItems.map((lineItem) => ({ ...lineItem }));
	const netTotal = roundHalfUpCurrency(
		working.reduce((sum, row) => sum + rowLineTotal(row), 0),
	);
	if (netTotal <= 0) {
		return { rows: working, targetDescription: '', feeDelta: 0 };
	}

	const grossTotal = calculateGrossUpAmount(netTotal);
	const feeDelta = roundHalfUpCurrency(grossTotal - netTotal);
	if (feeDelta <= 0) {
		return { rows: working, targetDescription: '', feeDelta: 0 };
	}

	const totals = working.map((row) => rowLineTotal(row));
	const targetIdx = totals.indexOf(Math.max(...totals));
	const target = working[targetIdx];
	const qty = Number(target.quantity) || 1;
	const targetLineTotal = roundHalfUpCurrency(totals[targetIdx] + feeDelta);
	const newUnitPrice = roundHalfUpCurrency(targetLineTotal / qty);

	const targetDescription =
		(target.description || '').trim() || 'the line with the highest total';
	const rows = working.map((row, index) => {
		if (index === targetIdx) {
			return {
				...row,
				unit_price: newUnitPrice,
				total: targetLineTotal,
			};
		}
		const lineTotal = roundHalfUpCurrency(rowLineTotal(row));
		return { ...row, total: lineTotal };
	});

	return {
		rows,
		targetDescription,
		feeDelta,
		grossTotal,
	};
};

export const previewStripeFeeOnLineItems = (rows) =>
	applyStripeFeeToHighestLineItem(rows || []);
